export const environment = {
  production: false,
  generalApiUrl: "https://dev-api.theglobe.nz/graphql",
  publicApiUrl: "https://dev-api.theglobe.nz/graphql/public",
  uploadUrl: "https://dev-api.theglobe.nz/",
  filePath: "https://theglobe-development.s3.amazonaws.com/",
  socketUrl:"https://dev-chat.theglobe.nz",
  placeHolderImageUrl: "/assets/images/No-Image-Placeholder.svg",
  stripePublishKey:
    "pk_test_51QyiZIIWLjXKbF1ux3gAJ1KrUKnaqa8pi0mnfsmM33G1CoJKulFknsEAqDFmpRFAAl3pfoGDruwwvFw80aDNtken00xhsllPXY",
  adminPanelUrl: "https://dev-admin.theglobe.nz/",
  frontendPath: "https://dev.theglobe.nz/",
  googleMapsApiKey:"AIzaSyB_PW4Pa_uetMvVJ_5Mtfnk7KNTA8mM29c",
  googleClientId: "149547806915-bgtjm8urjlikobkdhgjijpjqpnkncsql.apps.googleusercontent.com",
  port: 4000
};